// Brand marks are served from /assets rather than cdn.simpleicons.org so the
// page has no third-party runtime dependency. `navy` variants are the same mark
// recoloured to --navy (#123138) for use on light panels.
const icon = (slug) => (slug ? `/assets/${slug}.svg` : '');
const navyIcon = (slug) => (slug ? `/assets/${slug}-navy.svg` : '');

const withLogo = (rows) =>
  rows.map((row) => ({ ...row, logo: icon(row.slug), initial: row.name[0] }));

/** Marquee rows on the "works with what you already use" section. */
export const ecosystemRows = {
  data: withLogo([
    { name: 'Snowflake', slug: 'snowflake' },
    { name: 'Databricks', slug: 'databricks' },
    { name: 'NielsenIQ', slug: '' },
    { name: 'Circana', slug: '' },
    { name: 'Looker', slug: 'looker' },
    { name: 'Google Sheets', slug: 'googlesheets' },
    { name: 'SPINS', slug: '' },
  ]),
  marketing: withLogo([
    { name: 'Meta Ads', slug: 'meta' },
    { name: 'Google Ads', slug: 'googleads' },
    { name: 'TikTok', slug: 'tiktok' },
    { name: 'Google Analytics', slug: 'googleanalytics' },
    { name: 'Mailchimp', slug: 'mailchimp' },
    { name: 'Shopify', slug: 'shopify' },
    { name: 'Criteo', slug: '' },
  ]),
  workflow: withLogo([
    { name: 'Notion', slug: 'notion' },
    { name: 'HubSpot', slug: 'hubspot' },
    { name: 'Airtable', slug: 'airtable' },
    { name: 'Anthropic MCP', slug: 'anthropic' },
    { name: 'Figma', slug: 'figma' },
    { name: 'Asana', slug: 'asana' },
    { name: 'Zapier', slug: 'zapier' },
  ]),
};

/** Connector grid in the platform mock-up, drawn on a light panel. */
export const connectors = [
  { name: 'Snowflake', slug: 'snowflake' },
  { name: 'Databricks', slug: 'databricks' },
  { name: 'NielsenIQ', slug: '' },
  { name: 'Circana', slug: '' },
  { name: 'Meta Ads', slug: 'meta' },
  { name: 'Google Ads', slug: 'googleads' },
  { name: 'Google Analytics', slug: 'googleanalytics' },
  { name: 'Mailchimp', slug: 'mailchimp' },
  { name: 'Shopify', slug: 'shopify' },
  { name: 'Looker', slug: 'looker' },
  { name: 'Notion', slug: 'notion' },
  { name: 'HubSpot', slug: 'hubspot' },
  { name: 'TikTok', slug: 'tiktok' },
  { name: 'Google Sheets', slug: 'googlesheets' },
  { name: 'Airtable', slug: 'airtable' },
  { name: 'SPINS', slug: '' },
].map((row) => ({ ...row, logo: navyIcon(row.slug) }));
